import React from "react";

function Footer() {
  return (
    <footer className="bg-gray-900 shadow-md">
      <div className="max-w-7xl mx-auto py-4">
        <p className="text-white text-sm font-medium text-center">
          © Made with love 🧡🤍💚 by{" "}
          <span className="text-emerald-400 text-lg font-medium">
            CodeTirtho97
          </span>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
